














































































































import DictMixin from '@/mixins/dict-mixin';
import OpsLogServices from '@/services/opslog';
import RuleServices, { RuleDto } from '@/services/rule';
import { mixins } from 'vue-class-component';
import { Component, Watch } from 'vue-property-decorator';
import RuleForm1 from './rule-form-tab1.vue';
import RuleForm2 from './rule-form-tab2.vue';
import RuleForm3 from './rule-form-tab3.vue';
import RuleForm4 from './rule-form-tab4.vue';
import LogDetail from '../../../platform/pages/syslog/detail-drawer.vue';
import MenuMixin from '@/mixins/menu-mixin';
@Component({
  components: { RuleForm1, RuleForm2, RuleForm3, RuleForm4, LogDetail }
})
export default class RuleDetail extends mixins(DictMixin, MenuMixin) {
  ruleSrv = new RuleServices();

  visible = false;
  id: any = 0;
  baseJobInfo: any = {
    cronExpression: '0 0 2 * * ?',
    jobMode: 0,
    jobConfig: {
      rate: 0,
      runDateFormat: '',
      runDateStr: ''
    }
  };
  ruleDefinition: any = {
    logicalOperator: '||',
    ruleConditionList: []
  };
  info: RuleDto = {
    ...this.baseJobInfo,
    ruleDefinition: this.ruleDefinition,
    ruleActions: []
  };

  created() {
    this.id = this.$route.query.id;
  }

  @Watch('$route')
  onRouteChange() {
    this.id = this.$route.query.id;
    this.onIdChange();
  }

  subFieldList: any[] = [];
  subSyncDefs: any = {};
  inputdataConfig: any[] = [];
  @Watch('id')
  async onIdChange() {
    if (!this.id || this.$route.path != '/decision/rule/detail') return false;
    this.spinning = true;
    let res = await this.ruleSrv.getInfo(this.id);
    this.spinning = false;
    if (!res) return false;
    this.info = res;
    this.info.jobConfig = JSON.parse(this.info.jobConfig);
    this.info.ruleDefinition = JSON.parse(this.info.ruleDefinition);
    // this.info.ruleDataCode = JSON.parse(this.info.ruleDataCode);
    this.getLogs();
  }

  columns = [
    { title: '变更时间', dataIndex: 'createTime' },
    { title: '变更人', dataIndex: 'createUser' },
    { title: '变更备注', dataIndex: 'opsComment' },
    {
      title: '操作',
      dataIndex: 'action',
      scopedSlots: {
        customRender: 'action'
      }
    }
  ];
  logVisible: boolean = false;
  logDetail: any = {};
  logSrv = new OpsLogServices();
  logList = [];
  async getLogs() {
    this.logList = await this.logSrv.getList({ opsTargetType_eq: 'rule', opsTargetCode_eq: this.info.ruleCode });
  }
  openLogDetail(record: any) {
    this.logDetail = record;
    this.logVisible = true;
  }
}
